// ============================================
// ROLC OneROLC - API Client
// Version: 3.6.0
// ============================================

import { CONFIG } from '../config/constants.js';
import { getToken, getSessionId, setLastActivity } from '../utils/storage.js';

// ============================================
// Core API Call
// ============================================
export async function apiCall(action, payload = {}, retries = 3) {
    const token = getToken();
    const sessionId = getSessionId();

    const body = JSON.stringify({
        action,
        token,
        sessionId,
        ...payload
    });

    let lastError = null;

    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            const res = await fetch(CONFIG.API_URL, {
                method: 'POST',
                body: body
            });

            // Transient infrastructure errors — retry
            if (res.status === 404 || res.status === 504) {
                if (attempt < retries) {
                    await new Promise(r => setTimeout(r, 1500 * attempt));
                    continue;
                }
                throw new Error(`Server error ${res.status}`);
            }

            let data;
            try {
                data = await res.json();
            } catch (e) {
                // Non-JSON response (likely HTML 404) — retry
                if (attempt < retries) {
                    await new Promise(r => setTimeout(r, 1500 * attempt));
                    continue;
                }
                throw new Error('Server returned a non-JSON response.');
            }

            if (data.error) {
                console.log(`[API] ${action} → error:`, data.error, '| sent sessionId:', sessionId);
            }

            setLastActivity();
            return data;
        } catch (err) {
            lastError = err;
            if (attempt < retries) {
                await new Promise(r => setTimeout(r, 1500 * attempt));
                continue;
            }
            console.error(`[API] ${action} → failed after ${attempt} attempts:`, err);
            throw err;
        }
    }
}
